export enum DataLayerCustomDimensions {
  MentionedBrand = 'mentionedBrand',
  PageCategory = 'pageCategory',
  WordsCount = 'wordsCount',
  Language = 'language',
}
